import Handlebars from 'handlebars';

Handlebars.registerHelper('ifEvenOrLast', function (options) {
  if (options.data.index % 2 === 0) {
    return options.fn(this);
  } else if (options.data.index % 2 === 1 || options.data.last) {
    return options.inverse(this);
  }
});

Handlebars.registerHelper('ifOddOrLast', function (options) {
  if (options.data.index % 2 === 0) {
    return options.inverse(this);
  } else if (options.data.index % 2 === 1 || options.data.last) {
    return options.fn(this);
  }
});

const formatPrice = (product, priceField, locale = null, opts = {}) => {
  return new Intl.NumberFormat(locale || product.locale, {
    style: 'currency',
    currency: product.currency,
    ...opts,
  }).format(product[priceField]);
};

Handlebars.registerHelper('formatPrice', function (product, field) {
  return formatPrice(product, field);
});

Handlebars.registerHelper(
  'formatPriceAdvanced',
  function (product, field, locale, minimumFractionDigits, maximumFractionDigits) {
    return formatPrice(product, field, locale, { minimumFractionDigits, maximumFractionDigits });
  }
);

Handlebars.registerHelper('currencyCodeToSymbol', (currency, locale) => {
  if (!currency) {
    return undefined;
  }
  return new Intl.NumberFormat(locale, { style: 'currency', currency })
    .formatToParts(1)
    .find((x) => x.type === 'currency').value;
});

Handlebars.registerHelper('ifZero', function (value, options) {
  if (value === 0) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper('addUtm', function (url) {
  return url;
});

Handlebars.registerHelper('fixedNumber', function (number) {
  return number !== null && number !== undefined ? parseFloat(number).toFixed(0) : number;
});

Handlebars.registerHelper('math', (lvalue, operator, rvalue) => {
  lvalue = parseFloat(lvalue);
  rvalue = parseFloat(rvalue);
  return {
    '+': lvalue + rvalue,
    '-': lvalue - rvalue,
    '*': lvalue * rvalue,
    '/': lvalue / rvalue,
    '%': lvalue % rvalue,
  }[operator];
});

Handlebars.registerHelper('truncate', (str, len) => {
  if (str.length > len && str.length > 0) {
    let new_str = str.substr(0, len);
    new_str = str.substr(0, new_str.lastIndexOf(' '));
    new_str = new_str.length > 0 ? new_str : str.substr(0, len);
    return new Handlebars.SafeString(new_str + '...');
  }
  return str;
});

Handlebars.registerHelper('find', (array, key, value) => {
  return array?.find((element) => element[key] === value);
});

Handlebars.registerHelper('toFixed', (number, decimals) => {
  return number !== null && number !== undefined ? parseFloat(number).toFixed(decimals) : number;
});

Handlebars.registerHelper('replace', (string, find, replace) => {
  return string?.replace(find, replace);
});

Handlebars.registerHelper('replaceAll', (string, find, replace) => {
  return string?.replaceAll(find, replace);
});

Handlebars.registerHelper('discountPercentage', (baseValue, discountValue) => {
  if (!baseValue || !discountValue) {
    return undefined;
  }

  return Math.trunc(((baseValue - discountValue || 0) / baseValue) * 100.0);
});

Handlebars.registerHelper('isGTE', function (value, compareValue, options) {
  if (value >= compareValue) {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
});

Handlebars.registerHelper('ifFirst', function (array, options) {
  if (array && array.length > 0 && options.data.index === 0) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper('ifEven', function (options) {
  if (options.data.index % 2 === 0) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper('ifOdd', function (options) {
  if (options.data.index % 2 === 1) {
    return options.fn(this);
  }
  return options.inverse(this);
});

Handlebars.registerHelper('ifEquals', function (arg1, arg2, options) {
  return arg1 === arg2 ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('ifContains', function (string, substring, options) {
  return string.indexOf(substring) !== -1 ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('ifDatePast', function (dateString, options) {
  return new Date(dateString) < new Date() ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('ifDateFuture', function (dateString, options) {
  return new Date(dateString) > new Date() ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('parseInt', (value) => {
  return value !== null && value !== undefined ? parseInt(value) : value;
});

Handlebars.registerHelper('toString', (value) => {
  return value?.toString();
});

Handlebars.registerHelper('join', (array, delimiter) => {
  return array?.join(delimiter);
});

Handlebars.registerHelper('split', (string, delimiter) => {
  return string?.split(delimiter);
});

Handlebars.registerHelper('length', (array) => {
  return array?.length;
});

Handlebars.registerHelper('encodeURIComponent', (str) => {
  if (!str) {
    return;
  }
  return encodeURIComponent(str);
});

Handlebars.registerHelper('now', () => {
  return new Date().toISOString();
});

Handlebars.registerHelper('plusDays', (iso8601Date, days) => {
  const dateObj = new Date(iso8601Date);
  const parsedDays = parseInt(days);
  dateObj.setUTCDate(dateObj.getUTCDate() + parsedDays);
  return dateObj.toISOString().split('T')[0];
});

Handlebars.registerHelper('minusDays', (iso8601Date, days) => {
  const dateObj = new Date(iso8601Date);
  const parsedDays = parseInt(days);
  dateObj.setUTCDate(dateObj.getUTCDate() - parsedDays);
  return dateObj.toISOString().split('T')[0];
});

Handlebars.registerHelper('dateToLocaleFormat', (iso8601Date, locale) => {
  const dateObj = new Date(iso8601Date);
  return dateObj.toLocaleDateString(locale);
});

Handlebars.registerHelper('toLowerCase', (string) => {
  return string?.toLowerCase();
});

Handlebars.registerHelper('toUpperCase', (string) => {
  return string?.toUpperCase();
});

Handlebars.registerHelper('isNthElement', function (N, options) {
  const index = options.data.index;

  return (index + 1) % N === 0;
});

Handlebars.registerHelper('convertToEuro', function (price) {
  const conversionRate = 1.95583;

  if (typeof price !== 'number') {
    price = parseFloat(price);
  }

  if (isNaN(price)) {
    return '';
  }

  return (price / conversionRate).toFixed(2);
});

Handlebars.registerHelper('convertToBgn', function (price, currency) {
  const CONVERSION_RATES = {
    EUR: 1.95583,
    BGN: 1,
  };

  const numPrice = parseFloat(price);

  if (isNaN(numPrice) || !CONVERSION_RATES[currency]) {
    return '';
  }

  return (numPrice * CONVERSION_RATES[currency]).toFixed(2);
});

Handlebars.registerHelper('endsWith', function (string, find, options) {
  if (typeof string !== 'string' || typeof find !== 'string') {
    return options.inverse(this);
  }
  return string.endsWith(find) ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper(
  'formatPriceFlexible',
  function format(value, currency, locale, minimumFractionDigits, maximumFractionDigits) {
    if (value === null || value === undefined || value === '' || !locale || !currency) {
      return '';
    }

    const numericValue = parseFloat(value);

    if (isNaN(numericValue)) {
      return '';
    }

    const options = {
      style: 'currency',
      currency: currency,
      minimumFractionDigits,
      maximumFractionDigits,
    };

    return new Intl.NumberFormat(locale, options).format(numericValue);
  }
);
Handlebars.registerHelper('currentYear', () => {
  return new Date().getFullYear().toString();
});
